import React from 'react'
import StyledFlexContainer from '../../../../../components/containers/flex-container.component.jsx'
import {
	StyledImg,
	StyledMyOrder,
	StyledProductCode,
	StyledProductInfo,
	StyledProductName,
	StyledTotalContainer,
	StyledQuantityPointsContainer
} from './styled-components.component'

const initialValues = { quantity: 1 }

const MyOrder = ({
	productCode,
	productName,
	totalPoints,
	totalValue,
	imageUrl
}) => {
	const hasMoneyValue = totalValue > 0

	return (
		<StyledFlexContainer spaceBetween>
			<StyledMyOrder>
				<StyledImg alt={productName} src={imageUrl} />
				<StyledProductInfo>
					<StyledProductName className={'bold'}>
						{productName}
					</StyledProductName>
					<StyledProductCode>
						Código do produto: {productCode}
					</StyledProductCode>
				</StyledProductInfo>
			</StyledMyOrder>
			<StyledQuantityPointsContainer>
				<div className="quantity-order">
					<span className="quantity-word">
						Quantidade: <span className="quantity-value">1</span>
					</span>
				</div>
				<StyledTotalContainer>
					<p className={'center'}>
						Total de pontos
						<br />
						<br />
						<span className={'bold'}>
							{totalPoints} pontos
							{hasMoneyValue ? <br /> : null}
							{hasMoneyValue ? ` + ${totalValue.$toReais()}` : ''}
						</span>
					</p>
				</StyledTotalContainer>
			</StyledQuantityPointsContainer>
		</StyledFlexContainer>
	)
}

export default MyOrder
